/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import client from "./client";

/**
 * Deleting a file moves it here and keeps the stored object, so restore is
 * real. Only `deleteForever` / `empty` destroy bytes.
 */
export const listTrash = async () => {
  const { data } = await client.get("/drive/trash");
  return data.files || [];
};

export const restore = async (id) => {
  const { data } = await client.post(`/drive/trash/${id}/restore`);
  return data.file;
};

export const deleteForever = async (id) => {
  const { data } = await client.delete(`/drive/trash/${id}`);
  return data.file;
};

export const emptyTrash = async () => {
  const { data } = await client.post("/drive/trash/empty");
  return data.deleted ?? 0;
};
